import React from 'react';

const BackArrowIcon = () => {
    return (
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2L2 10L10 18" stroke="#49C2CB" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default BackArrowIcon;